import React, {useState} from "react"
import {Helmet} from "react-helmet"
import logo404 from "../assets/images/404.svg"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import {useNavigate} from "react-router"

const Page404 = () => {
  const navigate = useNavigate()
  const [seconds, setSeconds] = useState(3)

  setTimeout(() => {
    let counter = seconds - 1;
    setSeconds(counter);
    if (seconds < 1) {
      navigate("/");
    }
  }, 1000);
  return (
    <>
      <Helmet>
        <title>Error 404 | Tensolite</title>
      </Helmet>
      <div id="maqueta" className="bg-fullpage bg-404">
        <div className="card-info">
          <div className="cuadrado-azul"></div>
          <h1>Error 404 - Esta página no fue encontrada</h1>
          <p>
            Esta página no existe, verificar la dirección ingresada.
          </p>
          <img alt="Imagen de error Tensolite" src={logo404}></img>
          <button className="settings_button-pleno bg-p-secondary mt-3 float-end">
            <a className="d-flex justify-content-center align-items-center" href="/">
              Volver al sitio principal en {seconds} <ArrowForwardIcon />
            </a>
          </button>
        </div>
      </div>
    </>
  )
};

export default Page404;
